<template>
  <div class="p-grid" v-if="$ability.can('read', 'Service')">
    <div class="p-col-12" style="width: 100%; padding: 0">
      <ServiceTabs></ServiceTabs>
    </div>
    <div class="p-col-12">
      <ServiceListTable />
    </div>
    <router-link
      :to="createLink"
      style="text-decoration: none"
      v-if="$ability.can('write', 'Service')"
    >
      <AppFloatButton icon="pi pi-plus" />
    </router-link>
  </div>
  <AppPermissionAlert v-else />
</template>

<script>
import ServiceListTable from './components/ServiceListTable.vue';
import ServiceTabs from './components/ServiceTabs.vue';

export default {
  name: 'ServiceList',
  components: {
    ServiceListTable,
    ServiceTabs,
  },
  computed: {
    createLink() {
      if ((this.$route.name || '').includes('customer')) {
        return { name: 'customer-service.create' };
      }
      return { name: 'service.create' };
    },
  },
};
</script>

<style>
</style>